module.exports = __webpack_public_path__ + "img/g_mro_6.5be16444.png";